import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import api from '../../services/axios';
import AgentsSearchBar from './AgentsSearchBar';
import AgentsTable from './AgentsTable';
import Pagination from '../controls/Pagination';

const ShowAgents = (props) => {

  const { t } = useTranslation();

  const [agents, setAgents] = useState([])
  const [agentToFind, setAgentToFind] = useState('')
  const [textToFind, setTextToFind] = useState('');

  const [currrentPage, setCurrrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [perPage, setPerPage] = useState(8);

  const [errMsg, setErrMsg] = useState('');

  useEffect(() => {
    getAllAgents(agentToFind);
  }, [currrentPage, agentToFind, textToFind])

  const getAllAgents = async () => {
    try {
      const response =
        await api.get(`/react_agents?page=${currrentPage}&per_page=${perPage}&income_code=${agentToFind}&textToFind=${textToFind}`, {
          headers: {
            'Authorization': `Bearer ${props.loginParameters.accesToken}`
          }
        })
      setAgents(response.data.data)
      setLastPage(response.data.last_page)
      setPerPage(response.data.per_page)
      console.log('lastPage ' + lastPage);
      console.log('currrentPage ' + currrentPage);

    } catch (err) {
      if (!err?.response) {
        setErrMsg('No Server Response');
      } else if (err.response?.status === 400) {
        setErrMsg('Missing Username or Password');
      } else if (err.response?.status === 401) {
        setErrMsg('Unauthorized');
      } else {
        setErrMsg('Login Failed');
      }
    }
  }

  const paginate = (currrentPage) => {
    setCurrrentPage(currrentPage);
  }

  return (
    <div style={{ padding: "20px" }}>
      <AgentsSearchBar
        t={t}
        loginParameters={props.loginParameters}
        agentToFind={agentToFind}
        setAgentToFind={setAgentToFind}
        textToFind={textToFind}
        setTextToFind={setTextToFind}
        setCurrrentPage={setCurrrentPage}
      />
      
      <AgentsTable
        agents={agents}
        t={t}
      />

      <h4 className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</h4>

      <Pagination
        lastPage={lastPage}
        currrentPage={currrentPage}
        paginate={paginate}
      />
    </div>
  );
};

export default ShowAgents;